import { render, staticRenderFns } from "./UnauthorizedLayout.vue?vue&type=template&id=32a511c2"
import script from "./UnauthorizedLayout.vue?vue&type=script&lang=js"
export * from "./UnauthorizedLayout.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedLayout.vue?vue&type=style&index=0&id=32a511c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports